// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2swHY","largestCol":"styles_largestCol__nfWhT","smallestCol":"styles_smallestCol__rGEHr"};